import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { translations } from "@/lib/i18n";

const AppContext = createContext(null);

export const AppProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("afc_lang") || "en");
  const [currency, setCurrency] = useState(() => localStorage.getItem("afc_currency") || "AED");
  const [settings, setSettings] = useState({
    whatsapp_sales: "971545499994",
    whatsapp_management: "9647700055551",
    sales_name: "Taha",
    sales_phone: "+971 54 549 9994",
    management_name: "Hayder",
    management_phone: "+964 770 005 5551",
    location: "Dubai – DAFZA W5",
    email_sales: "sales@afc-telecom-uae.com",
    email_info: "info@afc-telecom-uae.com",
    default_currency: "AED",
    rate_usd: 0.272,
    rate_iqd: 356.6,
  });

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    document.body.setAttribute("dir", lang === "ar" ? "rtl" : "ltr");
    localStorage.setItem("afc_lang", lang);
  }, [lang]);

  useEffect(() => {
    localStorage.setItem("afc_currency", currency);
  }, [currency]);

  useEffect(() => {
    api.get("/settings").then((r) => {
      setSettings((s) => ({ ...s, ...r.data }));
    }).catch(() => {});
  }, []);

  const tr = translations[lang];

  return (
    <AppContext.Provider value={{ lang, setLang, currency, setCurrency, settings, setSettings, tr }}>
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error("useApp must be used inside AppProvider");
  return ctx;
};
